import { render, staticRenderFns } from "./EditTeacher.vue?vue&type=template&id=3be28a86&scoped=true&"
import script from "./EditTeacher.vue?vue&type=script&lang=js&"
export * from "./EditTeacher.vue?vue&type=script&lang=js&"
import style0 from "./EditTeacher.vue?vue&type=style&index=0&id=3be28a86&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be28a86",
  null
  
)

export default component.exports